module.exports = __webpack_public_path__ + "static/media/zumkha1-scop1.8d35b314.png";